import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import ThemeSwatches from './ThemeSwatches';
import { setFromZolaUpdate, updateCurrentTheme, storeCurrentThemeKey } from '../../../actions/website/ThemeActions';
// import { showModal } from '../../../actions/ModalActions';
import { createWeddingForRegistryAccountUser, createWeddingForExistingUser, updateWeddingTheme, fetchWeddingAccount, disableWebsiteOnboarding } from '../../../actions/WeddingActions';
import { trackOnboardingStarted, trackOnboardingCompleted } from '../../../util/trackingHelper';
import { callToAction } from '../../../pages/preauth/util/LandingPageCtaHelper';

class ThemeGroup extends Component {
  constructor(props) {
    super(props);
    let selectedTheme = props.themeGroup.themes[0];

    if (props.globallySelectedTheme && props.globallySelectedTheme.theme) {
      props.themeGroup.themes.forEach((themeGroupTheme) => {
        if (props.globallySelectedTheme.theme.id === themeGroupTheme.id) {
          selectedTheme = props.globallySelectedTheme.theme;
        }
      });
    }

    this.state = {
      themeGroup: props.themeGroup,
      locallySelectedTheme: selectedTheme,
      currentGroup: props.themeGroup,
      active: false,
      fromZola: false
    };
    this.changeThemeView = this.changeThemeView.bind(this);
    this.onCtaClick = this.onCtaClick.bind(this);
    this.getThemeDetailUrl = this.getThemeDetailUrl.bind(this);
    this.determineButtonAction = this.determineButtonAction.bind(this);
    this.generateTileCtas = this.generateTileCtas.bind(this);
    this.determineUserState = this.determineUserState.bind(this);
  }

  componentWillMount() {
    const { updateFromZolaStatus, fromZola } = this.props;
    this.setState({ fromZola: true }, () => updateFromZolaStatus(fromZola));
  }

  onSwatchClickHandler(theme) {
    this.props.onSwatchClick(theme);
    this.setState({
      active: !this.state.active
    });
  }

  onCtaClick() {
    // All users who have not selected a theme yet. Both guests and logged in users.
    const { userContext, onCreateWeddingforRegistryAccountUser, onCreateWeddingForOnboardedUser, onGuestCtaClick } = this.props;
    const currentTheme = this.state.locallySelectedTheme.id;
    const cookies = new Cookies();
    cookies.set('preauthSelectedWeddingTheme', currentTheme, { maxAge: 1800, path: '/' });
    if (userContext.has_registry) {
      onCreateWeddingforRegistryAccountUser();
    } else if (userContext.has_completed_onboarding) {
      onCreateWeddingForOnboardedUser();
    } else if (!userContext.is_guest) {
      // Weddings or other non-registry user without a website yet.
      setTimeout(trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true));
      browserHistory.push('/wedding/onboard?product=WEDDING_WEBSITE');
    } else if (userContext.is_guest) {
      onGuestCtaClick();
    }
  }

  // determining theme detail link
  getThemeDetailUrl(selectedThemeKey) {
    if (this.determineUserState() === 'postauth') {
      return `/wedding/manage/website/design/${selectedThemeKey}`;
    } if (this.determineUserState() === 'preauth') {
      return `/wedding-planning/website/design/${selectedThemeKey}`;
    }
    return null;
  }

  changeThemeView(theme) {
    this.setState({
      locallySelectedTheme: theme,
      active: !this.state.active
    });
  }

  // determines correct link / update action for wrapping tile button
  determineButtonAction(e) {
    const { themeGroup } = this.props;
    const selectedTheme = this.state.locallySelectedTheme;
    const selectedThemeKey = selectedTheme.key;
    const themeGroupKey = themeGroup.title.toLowerCase().split(' ').join('-');
    if (this.determineUserState() === 'postauth') {
      if (e.target !== this.tile && e.target !== this.selectButton && e.target !== this.editButton && e.target !== this.partnerButton) {
        browserHistory.push(this.getThemeDetailUrl(selectedThemeKey));
        this.updateCurrentTheme(selectedTheme, themeGroupKey);
      }
    } else if (this.determineUserState() === 'preauth') {
      if ((e.target !== this.tile && e.target !== this.selectButton && e.target !== this.editButton && e.target !== this.partnerButton)) {
        browserHistory.push(`/wedding-planning/website/design/${selectedThemeKey}`);
        this.updateCurrentTheme(selectedTheme);
      }
    }
  }

  updateCurrentTheme(currentTheme, themeGroupKey) {
    const { sendCurrentTheme, storeThemeKey } = this.props;
    sendCurrentTheme(currentTheme);
    storeThemeKey(currentTheme.key, themeGroupKey);
  }

  determineUserState() {
    const { userContext } = this.props;
    const hasRegistryIds = userContext.registry_ids ? userContext.registry_ids.length >= 0 : null;
    const hasNoRegistryIds = userContext.registry_ids ? userContext.registry_ids.length <= 0 : null;

    if ((hasRegistryIds && userContext.has_registry && userContext.has_wedding_account) || (userContext.has_wedding_account && !userContext.has_registry && hasNoRegistryIds)) {
      return 'postauth';
    } if ((hasRegistryIds && userContext.has_registry === true && !userContext.has_wedding_account) || (hasNoRegistryIds && userContext.has_wedding_account === null) || (userContext.is_guest) || (hasNoRegistryIds && !userContext.has_wedding_account)) {
      return 'preauth';
    }
    return null;
  }

  // generate ctas for various guest states
  generateTileCtas() {
    const { onboard, weddingTheme, setWeddingTheme, weddingSlug } = this.props;
    const selectedTheme = this.state.locallySelectedTheme;
    const selectedThemeKey = selectedTheme.key;
    if (this.determineUserState() === 'postauth') {
      if ((onboard) || (selectedTheme.key !== weddingTheme.key)) {
        return (
          <div className="actions hidden-xs hidden-sm">
            <div className="actions-wrapper">
              <button
                className="btn btn-primary theme-action"
                ref={(el) => {
                  this.tile = el;
                }}
                onClick={() => setWeddingTheme(selectedTheme.id, onboard)}
                key={1}
              >
              Select
              </button>
              <Link
                to={this.getThemeDetailUrl(selectedThemeKey)}
                className="btn btn-secondary theme-action"
                key={2}
              >
                View Details
              </Link>
            </div>
          </div>
        );
      } if (!onboard && selectedTheme.id === weddingTheme.id) {
        return (
          <div className="selected">
            <div className="checkmark-wrapper">
              <div className="checkmark">
                <i className="zolaicon zolaicon-checkmark" />
              </div>
              <div className="cta">
                <a href="/wedding/manage/website/pages" className="btn btn-primary" ref={(el) => { this.editButton = el; }}>Edit Website</a>
                <a
                  className="btn btn-secondary margin-top"
                  ref={(el) => { this.selectButton = el; }}
                  href={`/wedding/${weddingSlug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                Preview Website
                </a>
              </div>
            </div>
          </div>
        );
      }
    } else if (this.determineUserState() === 'preauth') {
      return (
        <div className="actions hidden-xs hidden-sm">
          <div className="actions-wrapper">
            <button
              className="btn btn-primary theme-action"
              ref={(el) => {
                this.tile = el;
              }}
              onClick={this.onCtaClick}
            >
              Select
            </button>
            <Link
              to={this.getThemeDetailUrl(selectedThemeKey)}
              className="btn btn-secondary theme-action"
            >
            View Details
            </Link>
          </div>
        </div>
      );
    }
    return false;
  }

  render() {
    const { themeGroup, themeIndex } = this.props;
    const theme = themeGroup.themes[0];
    const selectedTheme = this.state.locallySelectedTheme;
    const selectedThemeKey = selectedTheme.key;
    const themeGroupKey = themeGroup.title.toLowerCase().split(' ').join('-');
    if (themeIndex === 7 && this.determineUserState() === 'postauth') {
      return (
        <div className="theme-tile col-xs-12 col-sm-6 col-lg-3">
          <div className="theme-preview">
            <Link to="/wedding-planning/save-the-date/shop">
              <div className="marketing-module" />
            </Link>
          </div>
        </div>
      );
    }
    return (
      <div
        className={['theme-tile col-xs-12 col-sm-6 col-lg-3', themeGroupKey].join(' ')}
        id={selectedThemeKey}
      >
        <div
          role="button"
          onClick={e => this.determineButtonAction(e)}
        >
          <div className="theme-preview" style={{ backgroundImage: `url(${selectedTheme.preview_images[0]})` }}>
            {this.generateTileCtas()}
          </div>
          <h4 className="text-sans theme-title">
            {themeGroup.title} {themeGroup.is_new
              && <div className="zola-ui tag tag--lg tag--primary">NEW</div>
            }
          </h4>
        </div>
        <div className="swatches-partner-container">
          <ThemeSwatches themeOptions={themeGroup} onSwatchClick={this.changeThemeView} currentTheme={selectedTheme} pageName="themes" />
          {theme.partner_cta_label
          && (
          <span className="partner-cta text-muted">
            {theme.partner_cta_label}
            {theme.partner_cta_url ? (
              <a href={theme.partner_cta_url} target="_blank" rel="noopener noreferrer" ref={(el) => { this.partnerButton = el; }}>{` ${theme.partner_name}`}</a>
            ) : (
              <span>{` ${theme.partner_name}`}</span>
            )}
          </span>
          )
          }
        </div>
      </div>
    );
  }
}

ThemeGroup.propTypes = {
  themeGroup: PropTypes.shape({
    themes: PropTypes.arrayOf(
      PropTypes.shape({})
    ),
  }),
  weddingTheme: PropTypes.shape({}),
  setWeddingTheme: PropTypes.func,
  onboard: PropTypes.bool,
  weddingSlug: PropTypes.string,
  onSwatchClick: PropTypes.func,
  userContext: PropTypes.shape({}),
  onCreateWeddingforRegistryAccountUser: PropTypes.func.isRequired,
  onCreateWeddingForOnboardedUser: PropTypes.func.isRequired,
  updateFromZolaStatus: PropTypes.func.isRequired,
  fromZola: PropTypes.bool,
  sendCurrentTheme: PropTypes.func,
  globallySelectedTheme: PropTypes.shape({
    theme: PropTypes.shape({
      id: PropTypes.number
    })
  }),
  storeThemeKey: PropTypes.func,
  onGuestCtaClick: PropTypes.func,
  themeIndex: PropTypes.number

};

const mapStateToProps = state => ({
  weddingTheme: state.wedding.theme,
  onboard: !state.wedding.account.disable_website_onboarding,
  weddingSlug: state.wedding.wedding.slug,
  userContext: state.user.userContext,
  fromZola: state.website.themeListing.fromZola,
  globallySelectedTheme: state.website.themeListing.currentTheme ? state.website.themeListing.currentTheme : null
});

const mapDispatchToProps = dispatch => ({
  // openModal: (modalType, modalProps, modalOptions) => {
  //   dispatch(showModal(modalType, modalProps, modalOptions));
  // },
  updateFromZolaStatus: fromZola => dispatch(setFromZolaUpdate(fromZola)),
  onCreateWeddingforRegistryAccountUser: () => dispatch(createWeddingForRegistryAccountUser()).then(() => {
    setTimeout(trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true));
    setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', true));
    setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDING_WEBSITE', true));
    browserHistory.push('/wedding/manage/website/pages/home');
  }),
  onCreateWeddingForOnboardedUser: () => dispatch(createWeddingForExistingUser()).then(() => {
    setTimeout(trackOnboardingStarted('WEDDINGS', 'WEDDINGS', true));
    setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDINGS', true));
    setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDING_WEBSITE', true));
    browserHistory.push('/wedding/manage/website/pages/home');
  }),
  setWeddingTheme: (themeId, onboard) => {
    dispatch(updateWeddingTheme(themeId));
    if (onboard) {
      dispatch(fetchWeddingAccount()).then(() => {
        dispatch(disableWebsiteOnboarding());
        // TODO: Currently assume user onboarded to 'component: WEDDINGS' only is an existing user, might want to pass false to tracking function below in this case.
        setTimeout(trackOnboardingCompleted('WEDDINGS', 'WEDDING_WEBSITE', true));
        browserHistory.push('/wedding/manage/website/pages/home');
      });
    }
  },
  sendCurrentTheme: theme => dispatch(updateCurrentTheme(theme)),
  storeThemeKey: (themeKey, themeGroupKey) => dispatch(storeCurrentThemeKey(themeKey, themeGroupKey)),
  onGuestCtaClick: () => dispatch(callToAction('WEDDING_WEBSITE')),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThemeGroup);



// WEBPACK FOOTER //
// ./src/components/manage/website/ThemeGroup.jsx